import * as angular from "angular";
import { LOGS_SERVICE, LogsService } from "./logs.service";
import { configRoute } from "./logs.router";

import "@progress/kendo-ui/js/kendo.angular";
import "@progress/kendo-ui/js/kendo.core";
import "@progress/kendo-ui/js/kendo.data";
import "@progress/kendo-ui/js/kendo.grid";

export default angular
    .module("board.web.admin.logs", [
        "kendo.directives"
    ])
    .config(configRoute)
    .service(LOGS_SERVICE, LogsService)
    .name;


// WEBPACK FOOTER //
// ./app/logs/logs.module.ts